/* 扫描所有语言文件,并将子工程的对象加入相应的语言文件中 */
const requireComponent = require.context('./language', false, /\.js$/);
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    if (window.messages[componentConfig.default.language.id] != undefined) {
        for (var obj in componentConfig.default) {
            if (obj != 'language') {
                window.messages[componentConfig.default.language.id][obj] = componentConfig.default[obj];
            }
        }
    }
});
